import { useParams } from 'react-router';
import { defaultBasis, parsePeriod, periodParam, useUrlState } from './api';
import { DATE_BASIS } from './status';
import type { Scope } from './types';
import { PartnerDetail } from './PartnerDetail';

/** /settlements/customers/:partnerId、/settlements/suppliers/:partnerId：手机 push 页、桌面整页 */
export function PartnerDetailPage({ scope }: { scope: Scope }) {
  const { partnerId } = useParams();
  const [sp, set] = useUrlState();
  const period = parsePeriod(sp.get('period'));
  const b = sp.get('basis');
  const basis = b && DATE_BASIS[scope].some((o) => o.value === b) ? b : defaultBasis(scope);
  return (
    <PartnerDetail
      key={partnerId}
      scope={scope}
      partnerId={partnerId!}
      period={period}
      basis={basis}
      onPeriod={(p) => set({ period: periodParam(p) })}
      onBasis={(v) => set({ basis: v !== defaultBasis(scope) ? v : undefined })}
    />
  );
}
